import { Coins, MessageSquare } from 'lucide-react';
import Link from 'next/link';

/**
 * Creator-profile paid-DM entry (FRONT-310): price rides on the button, never
 * behind it. `priceCoins === 0` renders the Free variant (full paid flow,
 * zero-coin charge). Visibility (opted-out / unpriced / fields absent =
 * hidden, unexplained) is the callsite's job.
 */
export function DmEntryButton({ href, priceCoins }: { href: string; priceCoins: number }) {
  return (
    <Link
      href={href}
      className="flex h-9 shrink-0 items-center gap-2 rounded-full bg-red-primary px-4 text-sm font-semibold text-white transition-colors hover:bg-red-hover"
    >
      <MessageSquare className="size-4" strokeWidth={1.9} />
      Send message
      <span className="flex items-center gap-1.5 border-l border-white/20 pl-2.5 text-white/90 tabular-nums">
        {priceCoins === 0 ? (
          'Free'
        ) : (
          <>
            <Coins className="size-3.5" strokeWidth={2} />
            {priceCoins}
          </>
        )}
      </span>
    </Link>
  );
}
